import React from 'react';
import { Typography, Space, Button } from 'antd';
import { WarningFilled } from '@ant-design/icons';

import { PointInTime } from '~components/PointInTime';
import { EmailTemplates } from '~features/CustomerSupport';
import { useSuggestedPlan } from '~features/billing';
import { usePrerenderUserId, useCurrentPlan } from '../../../hooks/usePrerenderUser';

type RenderLimitTrial100NotificationProps = {
  notification: {
    description: string;
    createdAt: string; // ISO date string
    metadata?: {
      htmlContent?: string; // HTML content
    };
  };
};

function RenderLimitTrial100Notification({ notification }: RenderLimitTrial100NotificationProps) {
  const suggestedPlan = useSuggestedPlan();
  const userId = usePrerenderUserId();
  const planName = useCurrentPlan();

  const upgradePlanHref = EmailTemplates.buildFreeTrial100UsageHref({
    suggestedPlan: suggestedPlan?.name || '-',
    accountId: userId,
    currentPlan: planName.name,
  });

  return (
    <Space direction="vertical" size="large">
      <div>
        <Typography.Text strong>
          <PointInTime value={notification.createdAt} />
        </Typography.Text>
        <Typography.Title type="danger" level={4}>
          <WarningFilled /> {notification.description}
        </Typography.Title>
      </div>

      <div>
        {suggestedPlan && (
          <Typography.Paragraph>Recommended plan based on your usage: {suggestedPlan.name}.</Typography.Paragraph>
        )}

        <Typography.Paragraph>
          If you&apos;d like to discuss options, you can also reach out to our Customer Success team at{' '}
          <Typography.Link target="_blank" href="mailto:support@prerender.io">
            support@prerender.io
          </Typography.Link>
          .
        </Typography.Paragraph>
      </div>

      <Typography.Link target="_blank" rel="noreferrer" href={upgradePlanHref}>
        <Button type="primary">Upgrade my plan</Button>
      </Typography.Link>
    </Space>
  );
}

export default RenderLimitTrial100Notification;
